import React, { Component } from 'react'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"

class ResponsiveCarousel extends Component {
    render() {
        return (
            <Carousel autoPlay={true} interval={3000} infiniteLoop={true} stopOnHover={false} emulateTouch={true} >
                <div>
                    <img src="/images/shop08.jpg" alt='' />
                    <p className="legend">駄菓子屋付きシェアハウス</p>
                </div>
                <div>
                    <img src="/images/living06.jpg" alt='' />
                    <p className="legend">敷金・礼金・更新料なし</p>
                </div>
                <div>
                    <img src="/images/living07.jpg" alt='' />
                    <p className="legend">家電・家具付き</p>
                </div>
                <div>
                    <img src="/images/shop02.png" alt='' />
                    <p className="legend">駄菓子屋のレジ対応でお小遣い稼ぎ ※画像はイメージです</p>
                </div>
                <div>
                    <img src="/images/garden12.jpg" alt='' />
                    <p className="legend">中庭で家庭菜園可</p>
                </div>
                <div>
                    <img src="/images/terras03.jpg" alt='' />
                    <p className="legend">屋上テラスでリラックス</p>
                </div>
            </Carousel>
        )
    }
}

export default ResponsiveCarousel


// WEBPACK FOOTER //
// ./src/ResponsiveCarousel.js